<script setup lang="ts">
  import { useChatInfoBar } from '@/composables/useChatInfoBar';

  const {
    inputRef,
    infoBarText,
    isExpanded,
    isOpen,
    companyName,
    isSubmitDisabled,
    isInputDisabled,
    chameleonState,
    openInput,
    focusInput,
    expandBar,
    closeBar,
    onBlur,
    onKeyPress,
    onSubmit
  } = useChatInfoBar();
</script>

<template>
  <div
    :class="['chat-info-bar', { 'chat-info-bar--open': isOpen, 'chat-info-bar--expanded': isExpanded }, `chat-info-bar--state-${chameleonState}`]"
    @click.prevent.stop="focusInput">
    <div>
      <button
        class="chat-info-bar__btn-close"
        @click.prevent.stop="closeBar" />
    </div>
    <div class="chat-info-bar__center">
      <label
        for="userUrl"
        class="hidden" />
      <transition name="fade-chat">
        <input
          v-if="isOpen"
          ref="inputRef"
          v-model="companyName"
          type="text"
          name="companyName"
          class="chat-info-bar__input"
          :autofocus="true"
          :disabled="isInputDisabled"
          autocomplete="off"
          @click="expandBar"
          @blur="onBlur"
          @keyup="onKeyPress" />
        <div
          v-else
          class="chat-info-bar__text"
          @click.prevent.stop="openInput">
          {{ infoBarText }}
        </div>
      </transition>
    </div>
    <div>
      <button
        class="chat-info-bar__btn-open"
        @click.prevent.stop="expandBar" />
      <button
        class="chat-info-bar__btn-submit"
        :disabled="isSubmitDisabled"
        @click.prevent.stop="onSubmit" />
    </div>
  </div>
</template>
